<template>
  <div>
    <!-- <div class="img-type">
      <span style="color: #606266">图片类型</span>
      <el-select v-model="processType" size="small" placeholder="请选择" style="width: 150px" @change="get_menu">
        <el-option v-for="item in processTypeList" :key="item.processType" :label="item.processTypeDesc" :value="item.processType"> </el-option>
      </el-select>
    </div> -->
    <el-input placeholder="输入文件夹进行搜索" v-model="filterText" class="input-filter"> </el-input>
    <!-- <div class="setup"><span class="iconfont icon-xiazai" style="font-size: 20px" @click="onSetting"></span></div> -->
    <div class="setup">
      <el-button type="primary" class="green-btn" size="mini" @click="batchUploadVisible = true">批量上传</el-button>
      <el-button type="primary" class="orange-btn" size="mini" @click="onSetting">批量下载</el-button>
    </div>
    <!-- 报表文件 -->
    <div class="treeBox" ref="buildFloor" v-loading="loading || searching">
      <vxe-tree
        ref="tree"
        v-bind="treeOptions"
        @node-click="handleNodeClick"
        @node-expand="handleNodeExpand"
      >
        <template slot="title" slot-scope="{ node, isExpand }">
          <span class="my-custom">
            <template>
              <svg class="icon svg-icon" aria-hidden="true" v-show="!isExpand">
                <use xlink:href="#icon-folder"></use>
              </svg>
              <svg class="icon svg-icon" aria-hidden="true" v-show="isExpand">
                <use xlink:href="#icon-opened_folder"></use>
              </svg>
            </template>
            <span>{{ node.nodeName }}</span>
          </span>
        </template>
      </vxe-tree>
    </div>
    <!-- 设置 -->
    <setting :visible.sync="settingVisible" :modulesConfig="modulesConfig" :leftTreeData="sheetData" :processType="processType" @complete="get_menu" v-if="settingVisible"></setting>
    <!-- 批量上传 -->
    <batch-upload :visible.sync="batchUploadVisible" :processType="processType" @complete="get_menu" v-if="batchUploadVisible"></batch-upload>
  </div>
</template>

<script>
import setting from "./setting";
import batchUpload from "./batchUpload";
import tooltips from "../directive/tooltips/index.js";
import { VxeTree } from "vxe-pc-ui";
import "vxe-pc-ui/lib/style.css";

export default {
  components: { setting, batchUpload, VxeTree },
  props: ["modulesConfig", "processType"],
  directives: {
    tooltips,
  },
  data() {
    return {
      filterText: "",
      sheetData: [],
      loading: false,
      searching: false,
      selectVisible: false,
      settingVisible: false,
      batchUploadVisible: false,
      expandedKeys: [],
      selectedData: {},
      serchDataId: [],
      processTypeList: [],
      filterTimer: null,
      treeOptions: {
        loading: false,
        height: "100%",
        transform: true,
        keyField: "nodeId",
        parentField: "parentId",
        titleField: "nodeName",
        childrenField: "childrenList",
        mapChildrenField: "childrenList",
        showCheckbox: false,
        trigger: "node",
        nodeConfig: {
          isCurrent: true,
          currentMethod: ({ node }) => !node.disabled,
        },
        toggleMethod: ({ node }) => !node.disabled,
        virtualYConfig: {
          enabled: true,
          gt: 0,
          oSize: 10,
        },
      },
    };
  },
  created() {
    this._treeData = [];
    this._treeSearchIndex = [];
    this._treeSearchNodeMap = Object.create(null);
    this._searchRequestId = 0;
    this._searchTaskTimer = null;
  },
  watch: {
    filterText(val) {
      this.serchDataId = [];
      this.filterTree(val);
    },
  },
  mounted() {
    this.closeTooltip();
    // this.getProcessTypeList();
    this.get_menu();
  },
  methods: {
    // getProcessTypeList() {
    //   this.$q.newProduct.processTypeList().then(res=>{
    //     this.processTypeList = res.data || []
    //     this.processType = res.data.length ? res.data[0].processType : ''
    //     this.get_menu();
    //   })
    // },
    get_menu() {
      if (!this.processType) return Promise.resolve();
      this.cancelTreeSearch();
      this.loading = true;
      this.treeOptions.loading = true;
      const params = {
        params: {
          processType: this.processType,
        },
      };
      return this.$q.newProduct.pictureTreeMenus(params).then((res) => {
        this.sheetData = Array.isArray(res.data) ? res.data : [];
        const treeData = this.buildTreeData(this.sheetData);
        this._treeData = treeData;
        this.expandedKeys = [];
        this.$emit("initRight");
        return this.$nextTick().then(() => {
          return this.reloadTreeData(treeData, this._searchRequestId, []);
        }).then(() => {
          document.querySelectorAll(".el-tooltip__popper").forEach(function(el) {
            el.style.display = "none";
          });
        });
      }).finally(() => {
        this.loading = false;
        this.treeOptions.loading = false;
      });
    },
    // 将接口返回的嵌套树转换为 vxe-tree 的扁平数据，交给组件统一构建树
    buildTreeData(source) {
      const flatNodes = [];
      const searchIndex = [];
      const searchNodeMap = Object.create(null);
      const childrenMap = Object.create(null);
      const stack = [];
      const sourceList = Array.isArray(source) ? source : [];
      for (let index = sourceList.length - 1; index >= 0; index--) {
        stack.push({ item: sourceList[index], parentId: null });
      }
      while (stack.length) {
        const current = stack.pop();
        const item = current.item || {};
        const children = Array.isArray(item.childrenList) ? item.childrenList : [];
        const parentId = item.parentId === undefined ? current.parentId : item.parentId;
        const node = Object.assign({}, item, {
          parentId,
          childrenList: [],
        });
        const key = String(node.nodeId);
        const record = {
          key,
          parentKey: parentId === null || parentId === undefined ? null : String(parentId),
          node,
          name: String(node.nodeName || "").toLowerCase(),
        };
        flatNodes.push(node);
        searchIndex.push(record);
        searchNodeMap[key] = record;
        if (record.parentKey !== null) {
          if (!childrenMap[record.parentKey]) {
            childrenMap[record.parentKey] = [];
          }
          childrenMap[record.parentKey].push(key);
        }
        for (let index = children.length - 1; index >= 0; index--) {
          stack.push({ item: children[index], parentId: node.nodeId });
        }
      }
      searchIndex.forEach((record) => {
        record.childrenKeys = childrenMap[record.key] || [];
      });
      this._treeSearchIndex = searchIndex;
      this._treeSearchNodeMap = searchNodeMap;
      return flatNodes;
    },
    // 防止输入过程中重复执行搜索任务
    filterTree(value) {
      clearTimeout(this.filterTimer);
      clearTimeout(this._searchTaskTimer);
      const requestId = ++this._searchRequestId;
      const searchValue = String(value || "").trim();
      this.searching = Boolean(searchValue);
      this.filterTimer = setTimeout(() => {
        this.filterTimer = null;
        this.searchTree(searchValue, requestId);
      }, 250);
    },
    // 将大数据搜索拆成多个小任务，避免一次同步遍历阻塞页面
    searchTree(searchValue, requestId) {
      if (requestId !== this._searchRequestId) return;
      if (!searchValue) {
        this.reloadTreeData(this._treeData, requestId, []);
        return;
      }
      const query = searchValue.toLowerCase();
      const searchIndex = this._treeSearchIndex || [];
      const matchedKeys = Object.create(null);
      let index = 0;
      const searchChunk = () => {
        if (requestId !== this._searchRequestId) return;
        const startTime = Date.now();
        let handled = 0;
        while (index < searchIndex.length && handled < 500 && Date.now() - startTime < 8) {
          const record = searchIndex[index++];
          if (record.name.indexOf(query) > -1) {
            matchedKeys[record.key] = true;
          }
          handled++;
        }
        if (index < searchIndex.length) {
          this._searchTaskTimer = setTimeout(searchChunk, 0);
          return;
        }
        this.addSearchParentNodes(searchIndex, matchedKeys, requestId);
      };
      searchChunk();
    },
    // 搜索结果保留父级路径和命中节点的全部后代，保证树结构完整
    addSearchParentNodes(searchIndex, matchedKeys, requestId) {
      const matchedNodeKeys = Object.keys(matchedKeys);
      const expandKeys = Object.create(null);
      const nodeMap = this._treeSearchNodeMap || Object.create(null);
      const descendantQueue = matchedNodeKeys.map((key) => ({ key, childIndex: 0 }));
      const queuedKeys = Object.create(null);
      matchedNodeKeys.forEach((key) => {
        queuedKeys[key] = true;
      });
      let index = 0;
      const descendantChunk = () => {
        if (requestId !== this._searchRequestId) return;
        const startTime = Date.now();
        let handled = 0;
        while (index < descendantQueue.length && handled < 500 && Date.now() - startTime < 8) {
          const queueItem = descendantQueue[index];
          const record = nodeMap[queueItem.key];
          if (!record) {
            index++;
            continue;
          }
          const childrenKeys = record.childrenKeys || [];
          if (queueItem.childIndex >= childrenKeys.length) {
            index++;
            continue;
          }
          expandKeys[record.key] = true;
          const childKey = childrenKeys[queueItem.childIndex++];
          matchedKeys[childKey] = true;
          if (!queuedKeys[childKey]) {
            queuedKeys[childKey] = true;
            descendantQueue.push({ key: childKey, childIndex: 0 });
          }
          handled++;
        }
        if (index < descendantQueue.length) {
          this._searchTaskTimer = setTimeout(descendantChunk, 0);
          return;
        }
        this.addSearchParentNodesInChunks(matchedNodeKeys, matchedKeys, expandKeys, requestId);
      };
      descendantChunk();
    },
    addSearchParentNodesInChunks(matchedNodeKeys, matchedKeys, expandKeys, requestId) {
      const nodeMap = this._treeSearchNodeMap || Object.create(null);
      let index = 0;
      const parentChunk = () => {
        if (requestId !== this._searchRequestId) return;
        const startTime = Date.now();
        let handled = 0;
        while (index < matchedNodeKeys.length && handled < 200 && Date.now() - startTime < 8) {
          let record = nodeMap[matchedNodeKeys[index++]];
          while (record && record.parentKey !== null) {
            const parent = nodeMap[record.parentKey];
            if (!parent) break;
            matchedKeys[parent.key] = true;
            expandKeys[parent.key] = true;
            record = parent;
          }
          handled++;
        }
        if (index < matchedNodeKeys.length) {
          this._searchTaskTimer = setTimeout(parentChunk, 0);
          return;
        }
        this.collectSearchNodes(this._treeSearchIndex, matchedKeys, Object.keys(expandKeys), requestId);
      };
      parentChunk();
    },
    collectSearchNodes(searchIndex, matchedKeys, expandKeys, requestId) {
      const result = [];
      let index = 0;
      const collectChunk = () => {
        if (requestId !== this._searchRequestId) return;
        const startTime = Date.now();
        let handled = 0;
        while (index < searchIndex.length && handled < 500 && Date.now() - startTime < 8) {
          const record = searchIndex[index++];
          if (matchedKeys[record.key]) {
            result.push(record.node);
          }
          handled++;
        }
        if (index < searchIndex.length) {
          this._searchTaskTimer = setTimeout(collectChunk, 0);
          return;
        }
        this.reloadTreeData(result, requestId, expandKeys);
      };
      collectChunk();
    },
    // vxe-tree 会改写 childrenList，使用副本避免污染搜索索引
    reloadTreeData(nodes, requestId, expandNodeKeys) {
      const source = Array.isArray(nodes) ? nodes : [];
      const renderData = [];
      let index = 0;
      return new Promise((resolve) => {
        const copyChunk = () => {
          if (requestId !== this._searchRequestId) {
            resolve(null);
            return;
          }
          const startTime = Date.now();
          let handled = 0;
          while (index < source.length && handled < 500 && Date.now() - startTime < 8) {
            renderData.push(Object.assign({}, source[index++], { childrenList: [] }));
            handled++;
          }
          if (index < source.length) {
            this._searchTaskTimer = setTimeout(copyChunk, 0);
            return;
          }
          const tree = this.$refs.tree;
          if (!tree) {
            this.searching = false;
            resolve(null);
            return;
          }
          tree.reloadData(renderData).then(() => {
            if (requestId !== this._searchRequestId) return null;
            return tree.clearAllExpandNode();
          }).then(() => {
            if (requestId !== this._searchRequestId || !expandNodeKeys.length) return null;
            return tree.setExpandByNodeId(expandNodeKeys, true);
          }).finally(() => {
            if (requestId === this._searchRequestId) {
              this.searching = false;
            }
            resolve(null);
          });
        };
        copyChunk();
      });
    },
    cancelTreeSearch() {
      clearTimeout(this.filterTimer);
      clearTimeout(this._searchTaskTimer);
      this.filterTimer = null;
      this._searchTaskTimer = null;
      this._searchRequestId += 1;
      this.searching = false;
    },
    getNodeName(node) {
      return String((node && node.nodeName) || "");
    },
    // 节点点击
    handleNodeClick(params) {
      if (params && params.node && !params.node.disabled) {
        this.$emit("menu-click", params.node);
      }
    },
    // 节点展开、折叠
    handleNodeExpand(params) {
      if (!params || !params.node) return;
      const nodeId = params.node.nodeId;
      if (params.expanded) {
        if (!this.expandedKeys.includes(nodeId)) {
          this.expandedKeys.push(nodeId);
        }
      } else {
        this.expandedKeys = this.expandedKeys.filter((key) => key !== nodeId);
      }
    },
    // 设置
    onSetting() {
      this.settingVisible = true;
    },
    closeTooltip() {
      const hideTooltip = () => {
        document.querySelectorAll(".el-tooltip__popper").forEach(function(el) {
          el.style.display = "none";
        });
        const tree = this.$refs.tree;
        if (tree && tree.closeTooltip) {
          tree.closeTooltip();
        }
      };
      this.$refs.buildFloor.onscroll = hideTooltip.bind(this);
      const treeElement = this.$refs.tree && this.$refs.tree.$el;
      const treeList = treeElement && treeElement.querySelector(".vxe-tree--virtual-wrapper");
      if (treeList) {
        treeList.onscroll = hideTooltip.bind(this);
      }
    },
  },
  beforeDestroy() {
    this.cancelTreeSearch();
  },
};
</script>

<style lang="stylus" scoped>

.img-type
  padding 10px 10px 0 10px

.setup
  text-align right
  padding 0 10px
  margin-bottom: 10px

.treeBox
  height calc(100vh - 220px)
  overflow hidden

>>> .vxe-tree
  width 100%
  height 100%
  color #555 !important

>>> .vxe-tree--node-item
  width 100%
  box-sizing border-box

>>> .vxe-tree--node-item-title
  width 100%
  min-width 0

>>> .vxe-tree--node-item.is--current
  background-color rgba(36,198,154,0.3)

.sheet-tree
  position relative

.my-custom
  width 100%
  display flex
  align-items center
  padding-right 16px
  position relative
  overflow hidden
  text-overflow ellipsis
  white-space nowrap

.my-custom > span
  overflow hidden
  text-overflow ellipsis

.node-operate
  position absolute
  right 15px
  top 1px

.el-icon-star-on
  font-size 18.5px
  position relative
  top -1px
  color rgb(255,160,0)
.el-icon-star-off
  font-size 15px
  position relative
  top -2px
  color #999
.el-icon-s-tools
  font-size 18px
  color #1A936F

.input-filter
  width auto
  display block
  padding 10px
  >>> input
    height 32px

.icon {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  overflow: hidden;
  position relative
  top -1px
  flex none
}
.setup >>> .el-button {
  padding: 4px 8px;
  margin-left: 5px
}
</style>
